import React from "react";
import FetchSensorConfigs from "./FetchSensorConfigs";
import SensorTableList from "./SensorTableList";

const SensorListView = ({ allSensorSites }) => {


  console.log("SensorList allSensorSites", allSensorSites);

  return (
    <>
      {allSensorSites.length > 0 && allSensorSites.map((site, index) => <FetchSensorConfigs key={index} site={site} />)}
      <SensorTableList allSensorSites={allSensorSites} />
    </>
  );
};


export default SensorListView;
